import { DatePipe, DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BuildingAddressDirective } from '@cfp/shared/building/address-module';
import { EnergyLabel } from '@cfp/shared/energy-label';
import { StreetViewImageComponent } from '@cfp/shared/ui/street-view-image';
import { Badge, Icon } from '@cfp/ui';
import { TranslateModule } from '@ngx-translate/core';
import { EnergyLabelTypeDTO, LloydsRoadmapPortfolioBuildingDTO } from 'csr-asset-app';

@Component({
  selector: 'cfp-lbg-report-buildings-table',
  templateUrl: 'lbg-report-buildings-table.html',
  styleUrls: ['lbg-report-buildings-table.scss'],
  imports: [
    EnergyLabel,
    Icon,
    StreetViewImageComponent,
    BuildingAddressDirective,
    TranslateModule,
    DatePipe,
    DecimalPipe,
    Badge
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LbgReportBuildingsTable {
  public readonly buildings = input.required<LloydsRoadmapPortfolioBuildingDTO[]>();

  protected readonly EnergyLabelTypeDTO = EnergyLabelTypeDTO;
}
